
(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');


  const hideNativeStickyAtc = () => {
    document.body?.classList.remove('sticky-atc-bar-enabled');
    document.documentElement.style.setProperty('--sticky-atc-bar-height', '0px');

    document.querySelectorAll('.sticky-atc-bar, sticky-atc-bar').forEach((node) => {
      const container = node.classList?.contains('sticky-atc-bar') ? node : node.closest('.sticky-atc-bar');
      const section = node.closest('[id^="shopify-section-"]');
      [container, section].filter(Boolean).forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  };

  hideNativeStickyAtc();
  requestAnimationFrame(hideNativeStickyAtc);
  window.setTimeout(hideNativeStickyAtc, 250);
  window.setTimeout(hideNativeStickyAtc, 900);
  const nativeStickyObserver = new MutationObserver(hideNativeStickyAtc);
  nativeStickyObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => nativeStickyObserver.disconnect(), 5000);

  document.querySelectorAll('[data-asw-jewelry-pdp]').forEach((root) => {
    if (root.dataset.aswMobileBound === 'true') return;
    root.dataset.aswMobileBound = 'true';

    const q = (selector) => root.querySelector(selector);
    const hero = q('.asw-watch-pdp__hero');
    const gallery = q('[data-asw-lower-gallery]');
    if (!hero || !gallery) return;

    // Warm the lower gallery after the critical page content has loaded.
    // This keeps the hero fast while making thumbnail changes and zoom feel immediate.
    const bindGalleryWarmup = () => {
      const mediaItems = [...gallery.querySelectorAll('[data-asw-lower-media]')];
      const thumbControls = [...gallery.querySelectorAll('[data-asw-lower-media-target]')];
      if (!mediaItems.length || gallery.dataset.aswGalleryWarmup === 'true') return;
      gallery.dataset.aswGalleryWarmup = 'true';

      const displayCache = new Set();
      const fullCache = new Set();
      const probes = [];
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
      const constrainedConnection = Boolean(connection?.saveData) || /(^|-)2g$/.test(String(connection?.effectiveType || ''));
      const normalizeIndex = (index) => Math.max(0, Math.min(mediaItems.length - 1, Number(index) || 0));
      const activeIndex = () => {
        const controlIndex = thumbControls.findIndex((control) => control.getAttribute('aria-pressed') === 'true' || control.classList.contains('is-active'));
        if (controlIndex >= 0) return controlIndex;
        const mediaIndex = mediaItems.findIndex((item) => !item.hidden || item.classList.contains('is-active'));
        return Math.max(0, mediaIndex);
      };
      const scheduleIdle = (callback, timeout = 1400) => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, { timeout });
        } else {
          window.setTimeout(callback, 220);
        }
      };
      const keepProbe = (probe) => {
        probes.push(probe);
        const release = () => {
          const index = probes.indexOf(probe);
          if (index >= 0) probes.splice(index, 1);
        };
        probe.addEventListener?.('load', release, { once: true });
        probe.addEventListener?.('error', release, { once: true });
      };
      const preloadDisplay = (index, priority = 'low') => {
        const item = mediaItems[normalizeIndex(index)];
        const img = item?.querySelector('img');
        if (!img) return;
        const key = img.currentSrc || img.src || img.srcset || String(index);
        if (displayCache.has(key)) return;
        displayCache.add(key);

        const probe = new Image();
        probe.decoding = 'async';
        if ('fetchPriority' in probe) probe.fetchPriority = priority;
        if (img.srcset) {
          probe.srcset = img.srcset;
          probe.sizes = img.sizes || '100vw';
        }
        probe.src = img.currentSrc || img.src;
        keepProbe(probe);
      };
      const preloadFull = (index, priority = 'low') => {
        if (constrainedConnection) return;
        const item = mediaItems[normalizeIndex(index)];
        const url = item?.dataset?.aswFullImage || '';
        if (!url || fullCache.has(url)) return;
        fullCache.add(url);

        const probe = new Image();
        probe.decoding = 'async';
        if ('fetchPriority' in probe) probe.fetchPriority = priority;
        probe.src = url;
        keepProbe(probe);
      };
      const warmInteraction = (index) => {
        const center = normalizeIndex(index);
        preloadDisplay(center, 'high');
        preloadDisplay(center + 1, 'low');
        preloadDisplay(center - 1, 'low');
        preloadFull(center, 'high');
        window.setTimeout(() => preloadFull(center + 1, 'low'), 180);
        window.setTimeout(() => preloadFull(center - 1, 'low'), 360);
      };
      const indexForControl = (control) => {
        const target = control?.dataset?.aswLowerMediaTarget;
        if (!target) return -1;
        return mediaItems.findIndex((item) => String(item.dataset.aswLowerMedia) === String(target));
      };

      thumbControls.forEach((control) => {
        const warmControl = () => {
          const index = indexForControl(control);
          if (index >= 0) warmInteraction(index);
        };
        control.addEventListener('pointerenter', warmControl, { passive: true });
        control.addEventListener('focus', warmControl);
        control.addEventListener('touchstart', warmControl, { passive: true });
        control.addEventListener('click', warmControl);
      });

      gallery.addEventListener('click', (event) => {
        if (event.target.closest('[data-asw-lower-zoom-open], [data-asw-full-image]')) warmInteraction(activeIndex());
      });

      const backgroundWarmup = () => scheduleIdle(() => {
        if (document.visibilityState === 'hidden') return;
        const center = activeIndex();
        preloadDisplay(center, 'low');
        preloadDisplay(center + 1, 'low');
        preloadDisplay(center - 1, 'low');
        preloadFull(center, 'low');

        const remaining = mediaItems.map((_, index) => index).filter((index) => ![center, center + 1, center - 1].includes(index));
        const warmNextDisplay = () => {
          if (!remaining.length || document.visibilityState === 'hidden') return;
          preloadDisplay(remaining.shift(), 'low');
          if (remaining.length) window.setTimeout(() => scheduleIdle(warmNextDisplay, 1000), constrainedConnection ? 900 : 240);
        };
        window.setTimeout(warmNextDisplay, constrainedConnection ? 1200 : 320);

        if (!constrainedConnection) {
          window.setTimeout(() => preloadFull(center + 1, 'low'), 900);
          window.setTimeout(() => preloadFull(center - 1, 'low'), 1600);
        }
      });

      if (document.readyState === 'complete') backgroundWarmup();
      else window.addEventListener('load', backgroundWarmup, { once: true });
    };

    bindGalleryWarmup();
    const heylight = q('[data-asw-heylight]');
    const oneTimeButton = q('.asw-onetime-card__button');
    const oneTimePrice = q('.asw-onetime-card__price');
    const hasFinancing = Boolean(heylight);
    root.classList.toggle('asw-mobile-has-financing', hasFinancing);
    root.classList.toggle('asw-mobile-no-financing', !hasFinancing);

    const galleryHome = document.createComment('asw-mobile-gallery-home');
    gallery.parentNode.insertBefore(galleryHome, gallery);

    let trigger;
    let backdrop;
    let sticky;
    let cartSticky;
    let handle;
    let built = false;

    const lang = (root.getAttribute('lang') || 'en').slice(0, 2);
    const editText = lang === 'de' ? 'Finanzierung anpassen' : lang === 'fr' ? 'Modifier mon financement' : 'Edit my financing';
    const closeText = lang === 'de' ? 'Schließen' : lang === 'fr' ? 'Fermer' : 'Close';


    const sourceAmount = heylight?.querySelector('[data-asw-instalment-cta]') || null;
    const sourceAmountValue = () => sourceAmount?.querySelector('[data-asw-instalment-amount]')?.textContent?.trim() || '';
    const sourcePerMonth = () => sourceAmount?.querySelector('[data-asw-instalment-per-month]')?.textContent?.trim() || (lang === 'de' ? '/Monat' : lang === 'fr' ? '/mois' : '/month');
    const setMonthlyParts = (scope, valueSelector, suffixSelector) => {
      if (!scope) return;
      const valueNode = scope.querySelector(valueSelector);
      const suffixNode = scope.querySelector(suffixSelector);
      const value = sourceAmountValue();
      const suffix = sourcePerMonth();
      const sourceSuffixNode = sourceAmount?.querySelector('[data-asw-instalment-per-month]');
      if (sourceSuffixNode && sourceSuffixNode.textContent.trim() !== suffix) sourceSuffixNode.textContent = suffix;
      if (valueNode && valueNode.textContent.trim() !== value) valueNode.textContent = value;
      if (suffixNode && suffixNode.textContent.trim() !== suffix) suffixNode.textContent = suffix;
    };

    const oneTimeAmount = () => oneTimePrice?.textContent?.trim() || '';
    const syncAmount = () => {
      if (hasFinancing) {
        setMonthlyParts(trigger, '.asw-mobile-finance-trigger__value', '.asw-mobile-finance-trigger__per-month');
        setMonthlyParts(sticky, '.asw-mobile-finance-sticky__value', '.asw-mobile-finance-sticky__per-month');
      } else if (cartSticky) {
        const price = cartSticky.querySelector('.asw-mobile-cart-sticky__price');
        if (price) price.textContent = oneTimeAmount();
        const addButton = cartSticky.querySelector('.asw-mobile-cart-sticky__add');
        if (addButton && oneTimeButton) addButton.disabled = oneTimeButton.disabled;
      }
    };

    if (sourceAmount) {
      new MutationObserver(syncAmount).observe(sourceAmount, { childList: true, subtree: true, characterData: true });
      requestAnimationFrame(syncAmount);
      window.setTimeout(syncAmount, 120);
      window.setTimeout(syncAmount, 500);
    }

    let financeUnlockTimer = 0;
    const openFinance = () => {
      if (!mq.matches || !hasFinancing) return;
      window.clearTimeout(financeUnlockTimer);
      root.classList.add('asw-mobile-finance-open');
      document.documentElement.classList.add('asw-mobile-finance-lock');
      syncAmount();
    };

    const closeFinance = () => {
      root.classList.remove('asw-mobile-finance-open');
      window.clearTimeout(financeUnlockTimer);

      financeUnlockTimer = window.setTimeout(() => {
        document.documentElement.classList.remove('asw-mobile-finance-lock');
      }, 560);
    };

    const buildMobileGallery = () => {
      const stage = gallery.querySelector('.asw-watch-lower-gallery__stage');
      const media = [...gallery.querySelectorAll('[data-asw-lower-media]')];
      const sourceControls = [...gallery.querySelectorAll('[data-asw-lower-media-target]')];
      if (!stage || media.length < 1 || stage.dataset.aswMobileSwiper === 'true') return;
      stage.dataset.aswMobileSwiper = 'true';

      let programmaticChange = false;
      let transitioning = false;
      let drag = null;
      let suppressClickUntil = 0;
      const duration = 380;
      const easing = 'cubic-bezier(.22,.72,.20,1)';

      const activeIndex = () => {
        const controlIndex = sourceControls.findIndex((control) => control.getAttribute('aria-pressed') === 'true' || control.classList.contains('is-active'));
        if (controlIndex >= 0) return controlIndex;
        const mediaIndex = media.findIndex((item) => !item.hidden || item.classList.contains('is-active'));
        return Math.max(0, mediaIndex);
      };


      let pagination = gallery.querySelector('.asw-mobile-gallery-dots');
      if (!pagination && media.length > 1) {
        pagination = document.createElement('div');
        pagination.className = 'asw-mobile-gallery-dots';
        pagination.setAttribute('role', 'group');
        pagination.setAttribute('aria-label', 'Product media');
        stage.after(pagination);
      }

      const paginationButtons = [];
      if (pagination) {
        pagination.innerHTML = '';
        const rail = document.createElement('div');
        rail.className = 'asw-mobile-gallery-dots__rail';
        pagination.append(rail);
        media.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'asw-mobile-gallery-dot';
          button.setAttribute('aria-label', sourceControls[index]?.getAttribute('aria-label') || `Media ${index + 1}`);
          rail.append(button);
          paginationButtons.push(button);
        });
      }

      const syncPagination = (index = activeIndex()) => {
        paginationButtons.forEach((button, buttonIndex) => {
          const active = buttonIndex === index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };


      const mobilePreloaders = [];
      const preloadAround = (centerIndex = activeIndex()) => {
        const indexes = [centerIndex, centerIndex + 1, centerIndex - 1]
          .filter((index, position, list) => index >= 0 && index < media.length && list.indexOf(index) === position);

        indexes.forEach((i) => {
          const item = media[i];
          const img = item?.querySelector('img');
          if (!img || img.dataset.aswMobilePreloaded === 'true') return;
          img.dataset.aswMobilePreloaded = 'true';
          img.loading = 'eager';
          img.decoding = 'async';
          if ('fetchPriority' in img) img.fetchPriority = i === centerIndex ? 'high' : 'auto';

          const probe = new Image();
          probe.decoding = 'async';
          if ('fetchPriority' in probe) probe.fetchPriority = i === centerIndex ? 'high' : 'low';
          if (img.srcset) {
            probe.srcset = img.srcset;
            probe.sizes = img.sizes || '100vw';
          }
          probe.src = img.currentSrc || img.src;
          mobilePreloaders.push(probe);

          if (typeof img.decode === 'function') img.decode().catch(() => {});
        });
      };

      const layer = (item, z = 1) => {
        if (!item) return;
        item.hidden = false;
        item.classList.add('asw-mobile-slide-layer');
        item.style.position = 'absolute';
        item.style.inset = '0';
        item.style.width = '100%';
        item.style.height = '100%';
        item.style.margin = '0';
        item.style.zIndex = String(z);
        item.style.willChange = 'transform';
        item.style.animation = 'none';
      };

      const clearLayer = (item, hide = false) => {
        if (!item) return;
        item.classList.remove('asw-mobile-slide-layer');
        ['position','inset','width','height','margin','z-index','will-change','animation','transform','transition'].forEach((prop) => item.style.removeProperty(prop));
        if (hide) item.hidden = true;
      };

      const commitIndex = (index) => {
        if (index < 0 || index >= media.length) return;
        const control = sourceControls[index];
        if (control) {
          programmaticChange = true;
          control.click();
          programmaticChange = false;
        } else {
          media.forEach((item, itemIndex) => {
            item.hidden = itemIndex !== index;
            item.classList.toggle('is-active', itemIndex === index);
          });
        }
        syncPagination(index);
        preloadAround(index);
      };

      const animateTo = (targetIndex) => {
        if (!mq.matches || transitioning) return;
        const currentIndex = activeIndex();
        if (targetIndex === currentIndex || targetIndex < 0 || targetIndex >= media.length) return;

        if (reduceMotion.matches) {
          commitIndex(targetIndex);
          return;
        }

        const direction = targetIndex > currentIndex ? 1 : -1;
        const current = media[currentIndex];
        const target = media[targetIndex];
        const width = Math.max(1, stage.clientWidth);
        preloadAround(targetIndex);
        layer(current, 2);
        layer(target, 1);
        current.style.transform = 'translate3d(0,0,0)';
        target.style.transform = `translate3d(${direction * width}px,0,0)`;
        current.style.transition = `transform ${duration}ms ${easing}`;
        target.style.transition = `transform ${duration}ms ${easing}`;
        syncPagination(targetIndex);
        transitioning = true;

        requestAnimationFrame(() => requestAnimationFrame(() => {
          current.style.transform = `translate3d(${-direction * width}px,0,0)`;
          target.style.transform = 'translate3d(0,0,0)';
        }));

        window.setTimeout(() => {
          commitIndex(targetIndex);
          clearLayer(current, true);
          clearLayer(target, false);
          transitioning = false;
        }, duration + 35);
      };

      sourceControls.forEach((control, index) => {
        control.addEventListener('click', (event) => {
          if (!mq.matches || programmaticChange) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          animateTo(index);
        }, true);
      });

      paginationButtons.forEach((button, index) => {
        button.addEventListener('click', () => animateTo(index));
      });

      stage.addEventListener('touchstart', (event) => {
        if (!mq.matches || transitioning || event.touches.length !== 1 || event.target.closest('button')) return;
        const touch = event.touches[0];
        const index = activeIndex();
        drag = {
          startX: touch.clientX,
          startY: touch.clientY,
          x: touch.clientX,
          y: touch.clientY,
          index,
          current: media[index],
          target: null,
          targetIndex: -1,
          direction: 0,
          horizontal: false,
          vertical: false
        };
      }, { passive: true });

      stage.addEventListener('touchmove', (event) => {
        if (!mq.matches || !drag || event.touches.length !== 1) return;
        const touch = event.touches[0];
        drag.x = touch.clientX;
        drag.y = touch.clientY;
        const dx = drag.x - drag.startX;
        const dy = drag.y - drag.startY;

        if (!drag.horizontal && !drag.vertical) {
          if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            drag.vertical = true;
            return;
          }
          drag.horizontal = true;
          layer(drag.current, 2);
        }
        if (drag.vertical) return;
        event.preventDefault();

        const width = Math.max(1, stage.clientWidth);
        const direction = dx < 0 ? 1 : -1;
        const nextIndex = drag.index + direction;

        if (nextIndex < 0 || nextIndex >= media.length) {
          if (drag.target) {
            clearLayer(drag.target, true);
            drag.target = null;
            drag.targetIndex = -1;
          }
          drag.direction = 0;
          drag.current.style.transform = `translate3d(${dx * .22}px,0,0)`;
          return;
        }

        if (drag.targetIndex !== nextIndex) {
          if (drag.target) clearLayer(drag.target, true);
          drag.targetIndex = nextIndex;
          drag.direction = direction;
          drag.target = media[nextIndex];
          preloadAround(nextIndex);
          layer(drag.target, 1);
        }

        drag.current.style.transform = `translate3d(${dx}px,0,0)`;
        drag.target.style.transform = `translate3d(${dx + direction * width}px,0,0)`;
      }, { passive: false });

      const finishDrag = () => {
        if (!drag) return;
        const state = drag;
        drag = null;
        if (!state.horizontal) return;

        const width = Math.max(1, stage.clientWidth);
        const dx = state.x - state.startX;
        const commit = state.target && Math.abs(dx) >= Math.min(68, width * .15);
        state.current.style.transition = `transform ${duration}ms ${easing}`;
        if (state.target) state.target.style.transition = `transform ${duration}ms ${easing}`;
        suppressClickUntil = Date.now() + duration + 180;

        if (commit) {
          transitioning = true;
          syncPagination(state.targetIndex);
          state.current.style.transform = `translate3d(${-state.direction * width}px,0,0)`;
          state.target.style.transform = 'translate3d(0,0,0)';
          window.setTimeout(() => {
            commitIndex(state.targetIndex);
            clearLayer(state.current, true);
            clearLayer(state.target, false);
            transitioning = false;
          }, duration + 35);
        } else {
          state.current.style.transform = 'translate3d(0,0,0)';
          if (state.target) state.target.style.transform = `translate3d(${state.direction * width}px,0,0)`;
          window.setTimeout(() => {
            clearLayer(state.current, false);
            if (state.target) clearLayer(state.target, true);
          }, duration + 35);
        }
      };

      stage.addEventListener('touchend', finishDrag, { passive: true });
      stage.addEventListener('touchcancel', finishDrag, { passive: true });

      stage.addEventListener('click', (event) => {
        if (Date.now() >= suppressClickUntil) return;
        if (!event.target.closest('[data-asw-lower-media]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      window.addEventListener('resize', () => {
        if (!mq.matches) return;
        syncPagination(activeIndex());
      }, { passive: true });

      stage._aswMobileGallery = {
        media,
        activeIndex,
        activeMedia: () => media[activeIndex()] || null,
        setIndex: (index, animate = false) => animate ? animateTo(index) : commitIndex(index),
        syncPagination,
        refresh: () => syncPagination(activeIndex())
      };

      syncPagination(activeIndex());
      preloadAround(activeIndex());
    };

    const bindMobileLightbox = () => {
      const lightbox = q('[data-asw-lightbox]');
      const figure = lightbox?.querySelector('.asw-watch-lightbox__figure');
      const image = lightbox?.querySelector('[data-asw-lightbox-image]');
      const count = lightbox?.querySelector('[data-asw-lightbox-count]');
      const prev = lightbox?.querySelector('[data-asw-lightbox-prev]');
      const next = lightbox?.querySelector('[data-asw-lightbox-next]');
      const close = lightbox?.querySelector('[data-asw-zoom-close]');
      const mainStage = gallery.querySelector('.asw-watch-lower-gallery__stage');
      const galleryApi = mainStage?._aswMobileGallery;
      const imageItems = [...gallery.querySelectorAll('[data-asw-full-image]')];
      if (!lightbox || !figure || !image || !prev || !next || !mainStage || imageItems.length < 1 || lightbox.dataset.aswMobileSwipe === 'true') return;
      lightbox.dataset.aswMobileSwipe = 'true';

      const lightboxHome = lightbox.parentNode;
      if (count) {
        count.setAttribute('aria-hidden', 'true');
        count.style.display = 'none';
      }

      let mobileStage = figure.querySelector('.asw-mobile-lightbox-stage');
      if (!mobileStage) {
        mobileStage = document.createElement('div');
        mobileStage.className = 'asw-mobile-lightbox-stage';
        image.before(mobileStage);
        mobileStage.append(image);
      }

      let dots = figure.querySelector('.asw-mobile-lightbox-dots');
      let dotButtons = [];
      if (!dots && imageItems.length > 1) {
        dots = document.createElement('div');
        dots.className = 'asw-mobile-lightbox-dots';
        const rail = document.createElement('div');
        rail.className = 'asw-mobile-gallery-dots__rail';
        dots.append(rail);
        imageItems.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'asw-mobile-gallery-dot';
          button.setAttribute('aria-label', `Image ${index + 1}`);
          rail.append(button);
          dotButtons.push(button);
        });
        figure.append(dots);
      } else if (dots) {
        dotButtons = [...dots.querySelectorAll('.asw-mobile-gallery-dot')];
        dots.querySelector('.asw-mobile-gallery-dot-indicator')?.remove();
      }

      let currentIndex = 0;
      let openedFromMainIndex = 0;
      let drag = null;
      let animating = false;
      let closing = false;
      let ghost = null;
      let stageFlight = null;
      const duration = 380;
      const flightDuration = 660;
      const easing = 'cubic-bezier(.22,.72,.20,1)';
      const flightEasing = 'cubic-bezier(.16,.84,.23,1)';

      const itemIndexFromMain = () => {
        const activeMedia = galleryApi?.activeMedia?.();
        const index = imageItems.indexOf(activeMedia);
        return index >= 0 ? index : 0;
      };

      const syncDots = (index = currentIndex) => {
        dotButtons.forEach((button, buttonIndex) => {
          const active = buttonIndex === index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const normalizeIndex = (index) => (index + imageItems.length) % imageItems.length;
      const setImageSource = (index) => {
        const item = imageItems[index];
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = item?.dataset.aswFullImage || '';
        image.alt = item?.dataset.aswFullAlt || '';
      };

      const clearGhost = () => {
        ghost?.remove();
        ghost = null;
      };

      const createGhost = (targetIndex, direction, width) => {
        clearGhost();
        const item = imageItems[targetIndex];
        ghost = document.createElement('img');
        ghost.className = 'asw-mobile-lightbox-ghost';
        ghost.alt = item?.dataset.aswFullAlt || '';
        ghost.src = item?.dataset.aswFullImage || '';
        ghost.style.transform = `translate3d(${direction * width}px,0,0)`;
        mobileStage.append(ghost);
        if (typeof ghost.decode === 'function') ghost.decode().catch(() => {});
        return ghost;
      };

      const clearStageFlight = () => {
        if (stageFlight) {
          try { stageFlight.cancel(); } catch (_) {}
          stageFlight = null;
        }
        mobileStage.style.removeProperty('transform');
        mobileStage.style.removeProperty('opacity');
      };

      const clearMotion = () => {
        image.style.removeProperty('transition');
        image.style.removeProperty('transform');
        image.style.removeProperty('opacity');
        clearGhost();
      };

      const finishCommit = (targetIndex) => {
        currentIndex = normalizeIndex(targetIndex);
        setImageSource(currentIndex);
        syncDots(currentIndex);
        image.style.transition = 'none';
        image.style.transform = 'translate3d(0,0,0)';
        image.style.opacity = '1';
        clearGhost();
        requestAnimationFrame(() => image.style.removeProperty('transition'));
        animating = false;
      };

      const slideTo = (targetIndex, direction) => {
        if (!mq.matches || animating || closing || imageItems.length < 2) return;
        targetIndex = normalizeIndex(targetIndex);
        if (targetIndex === currentIndex) return;
        if (reduceMotion.matches) {
          finishCommit(targetIndex);
          return;
        }
        const width = Math.max(1, mobileStage.clientWidth);
        const target = createGhost(targetIndex, direction, width);
        image.style.transition = `transform ${duration}ms ${easing}`;
        target.style.transition = `transform ${duration}ms ${easing}`;
        syncDots(targetIndex);
        animating = true;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          image.style.transform = `translate3d(${-direction * width}px,0,0)`;
          target.style.transform = 'translate3d(0,0,0)';
        }));
        window.setTimeout(() => finishCommit(targetIndex), duration + 35);
      };

      const rectTransform = (from, to) => {
        const fromCx = from.left + from.width / 2;
        const fromCy = from.top + from.height / 2;
        const toCx = to.left + to.width / 2;
        const toCy = to.top + to.height / 2;
        const scaleX = to.width / Math.max(1, from.width);
        const scaleY = to.height / Math.max(1, from.height);
        return `translate3d(${toCx - fromCx}px,${toCy - fromCy}px,0) scale(${scaleX},${scaleY})`;
      };

      const animateOpenFromGallery = () => {
        openedFromMainIndex = itemIndexFromMain();
        currentIndex = openedFromMainIndex;
        setImageSource(currentIndex);
        syncDots(currentIndex);
        clearMotion();
        clearStageFlight();
        closing = false;
        if (reduceMotion.matches) return;

        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (lightbox.hidden) return;
          const from = mainStage.getBoundingClientRect();
          const to = mobileStage.getBoundingClientRect();
          if (!from.width || !from.height || !to.width || !to.height) return;
          const startTransform = rectTransform(to, from);
          stageFlight = mobileStage.animate([
            { transform: startTransform, opacity: .96 },
            { transform: 'translate3d(0,0,0) scale(1,1)', opacity: 1 }
          ], { duration: flightDuration, easing: flightEasing, fill: 'both' });
          stageFlight.finished.then(() => {
            if (stageFlight) {
              try { stageFlight.cancel(); } catch (_) {}
              stageFlight = null;
            }
          }).catch(() => {});
        }));
      };

      const finishClose = () => {
        clearMotion();
        clearStageFlight();
        lightbox.hidden = true;
        document.documentElement.classList.remove('asw-lightbox-open');
        if (lightboxHome && lightbox.parentNode !== lightboxHome) lightboxHome.appendChild(lightbox);
        closing = false;
        animating = false;
      };

      const animateCloseToGallery = (event) => {
        if (!mq.matches || lightbox.hidden || closing) return;
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        closing = true;
        animating = true;
        clearMotion();
        clearStageFlight();

        if (reduceMotion.matches) {
          finishClose();
          return;
        }

        const from = mobileStage.getBoundingClientRect();
        const to = mainStage.getBoundingClientRect();
        if (!from.width || !from.height || !to.width || !to.height) {
          finishClose();
          return;
        }
        const endTransform = rectTransform(from, to);
        stageFlight = mobileStage.animate([
          { transform: 'translate3d(0,0,0) scale(1,1)', opacity: 1 },
          { transform: endTransform, opacity: .96 }
        ], { duration: flightDuration, easing: flightEasing, fill: 'both' });
        stageFlight.finished.then(finishClose).catch(finishClose);
      };

      new MutationObserver(() => {
        if (!mq.matches) return;
        if (!lightbox.hidden) animateOpenFromGallery();
        else if (!closing) {
          clearMotion();
          clearStageFlight();
        }
      }).observe(lightbox, { attributes: true, attributeFilter: ['hidden'] });

      const interceptArrow = (button, direction) => {
        button.addEventListener('click', (event) => {
          if (!mq.matches || lightbox.hidden) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          slideTo(currentIndex + direction, direction);
        }, true);
      };
      interceptArrow(prev, -1);
      interceptArrow(next, 1);

      dotButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          if (!mq.matches || index === currentIndex) return;
          const direction = index > currentIndex ? 1 : -1;
          slideTo(index, direction);
        });
      });

      const beginPreviewDrag = (clientX, clientY) => {
        if (!mq.matches || animating || closing || lightbox.hidden) return false;
        drag = {
          startX: clientX,
          startY: clientY,
          x: clientX,
          y: clientY,
          currentIndex,
          targetIndex: -1,
          direction: 0,
          horizontal: false,
          vertical: false
        };
        image.style.transition = 'none';
        return true;
      };

      const movePreviewDrag = (clientX, clientY, preventDefault) => {
        if (!drag) return;
        drag.x = clientX;
        drag.y = clientY;
        const dx = drag.x - drag.startX;
        const dy = drag.y - drag.startY;
        if (!drag.horizontal && !drag.vertical) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            drag.vertical = true;
            return;
          }
          drag.horizontal = true;
        }
        if (drag.vertical) return;
        preventDefault?.();

        const width = Math.max(1, mobileStage.clientWidth);
        const direction = dx < 0 ? 1 : -1;
        const targetIndex = normalizeIndex(drag.currentIndex + direction);
        if (drag.targetIndex !== targetIndex) {
          drag.targetIndex = targetIndex;
          drag.direction = direction;
          createGhost(targetIndex, direction, width);
        }
        image.style.transform = `translate3d(${dx}px,0,0)`;
        if (ghost) ghost.style.transform = `translate3d(${dx + direction * width}px,0,0)`;
      };

      const finishPreviewDrag = () => {
        if (!drag) return;
        const state = drag;
        drag = null;
        if (!state.horizontal || !ghost) {
          clearMotion();
          return;
        }
        const width = Math.max(1, mobileStage.clientWidth);
        const dx = state.x - state.startX;
        const commit = Math.abs(dx) >= Math.min(66, width * .14);
        image.style.transition = `transform ${duration}ms ${easing}`;
        ghost.style.transition = `transform ${duration}ms ${easing}`;
        if (!commit) {
          image.style.transform = 'translate3d(0,0,0)';
          ghost.style.transform = `translate3d(${state.direction * width}px,0,0)`;
          window.setTimeout(clearMotion, duration + 35);
          return;
        }
        animating = true;
        syncDots(state.targetIndex);
        image.style.transform = `translate3d(${-state.direction * width}px,0,0)`;
        ghost.style.transform = 'translate3d(0,0,0)';
        window.setTimeout(() => finishCommit(state.targetIndex), duration + 35);
      };

      if (window.PointerEvent) {
        let previewPointerId = null;
        mobileStage.addEventListener('pointerdown', (event) => {
          if (!mq.matches || event.button !== undefined && event.button !== 0 || event.target.closest('button')) return;
          if (!beginPreviewDrag(event.clientX, event.clientY)) return;
          previewPointerId = event.pointerId;
          try { mobileStage.setPointerCapture(previewPointerId); } catch (_) {}
        });
        mobileStage.addEventListener('pointermove', (event) => {
          if (previewPointerId === null || event.pointerId !== previewPointerId) return;
          movePreviewDrag(event.clientX, event.clientY, () => event.preventDefault());
        });
        const endPointerDrag = (event) => {
          if (previewPointerId === null || event.pointerId !== previewPointerId) return;
          try { mobileStage.releasePointerCapture(previewPointerId); } catch (_) {}
          previewPointerId = null;
          finishPreviewDrag();
        };
        mobileStage.addEventListener('pointerup', endPointerDrag);
        mobileStage.addEventListener('pointercancel', endPointerDrag);
      } else {
        mobileStage.addEventListener('touchstart', (event) => {
          if (!mq.matches || event.touches.length !== 1 || event.target.closest('button')) return;
          const touch = event.touches[0];
          beginPreviewDrag(touch.clientX, touch.clientY);
        }, { passive: true });
        mobileStage.addEventListener('touchmove', (event) => {
          if (!drag || event.touches.length !== 1) return;
          const touch = event.touches[0];
          movePreviewDrag(touch.clientX, touch.clientY, () => event.preventDefault());
        }, { passive: false });
        mobileStage.addEventListener('touchend', finishPreviewDrag, { passive: true });
        mobileStage.addEventListener('touchcancel', finishPreviewDrag, { passive: true });
      }

      close?.addEventListener('click', animateCloseToGallery, true);
      lightbox.addEventListener('click', (event) => {
        if (!mq.matches || event.target !== lightbox) return;
        animateCloseToGallery(event);
      }, true);

      document.addEventListener('keydown', (event) => {
        if (!mq.matches || lightbox.hidden) return;
        if (event.key === 'Escape') {
          animateCloseToGallery(event);
          return;
        }
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        slideTo(currentIndex + direction, direction);
      }, true);

      window.addEventListener('resize', () => {
        if (!mq.matches || lightbox.hidden) return;
        syncDots(currentIndex);
      }, { passive: true });
    };

    const buildMobileUi = () => {
      if (built) return;
      built = true;

      const activeImage = q('.asw-watch-lower-gallery__media.is-active img') || q('.asw-watch-lower-gallery__media img');

      if (hasFinancing) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'asw-mobile-finance-trigger';
        trigger.innerHTML = '<span class="asw-mobile-finance-trigger__monthly"><span class="asw-mobile-finance-trigger__value"></span><span class="asw-mobile-finance-trigger__per-month"></span></span>';
        heylight.before(trigger);

        backdrop = document.createElement('div');
        backdrop.className = 'asw-mobile-finance-backdrop';
        root.append(backdrop);

        handle = document.createElement('button');
        handle.type = 'button';
        handle.className = 'asw-mobile-finance-handle';
        handle.setAttribute('aria-label', closeText);
        heylight.prepend(handle);

        sticky = document.createElement('div');
        sticky.className = 'asw-mobile-finance-sticky';
        sticky.innerHTML = `
          ${activeImage ? `<img src="${activeImage.currentSrc || activeImage.src}" alt="">` : ''}
          <div class="asw-mobile-finance-sticky__copy">
            <span class="asw-mobile-finance-sticky__amount"><span class="asw-mobile-finance-sticky__value"></span><span class="asw-mobile-finance-sticky__per-month"></span></span>
            <button type="button" class="asw-mobile-finance-sticky__edit">${editText}</button>
          </div>
          <button type="button" class="asw-mobile-finance-sticky__open" aria-label="${editText}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>
          </button>`;
        root.append(sticky);

        trigger.addEventListener('click', openFinance);
        backdrop.addEventListener('click', closeFinance);
        handle.addEventListener('click', closeFinance);
        sticky.querySelector('.asw-mobile-finance-sticky__edit').addEventListener('click', openFinance);
        sticky.querySelector('.asw-mobile-finance-sticky__open').addEventListener('click', () => {
          root.classList.contains('asw-mobile-finance-open') ? closeFinance() : openFinance();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && root.classList.contains('asw-mobile-finance-open')) closeFinance();
        });


      } else {

        cartSticky = document.createElement('div');
        cartSticky.className = 'asw-mobile-cart-sticky';
        const addLabel = oneTimeButton?.getAttribute('aria-label') || 'Add to cart';
        cartSticky.innerHTML = `
          ${activeImage ? `<img src="${activeImage.currentSrc || activeImage.src}" alt="">` : ''}
          <div class="asw-mobile-cart-sticky__copy">
            <span class="asw-mobile-cart-sticky__price"></span>
          </div>
          <button type="button" class="asw-mobile-cart-sticky__add" aria-label="${addLabel.replace(/"/g, '&quot;')}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>
          </button>`;
        root.append(cartSticky);

        const addButton = cartSticky.querySelector('.asw-mobile-cart-sticky__add');
        addButton.addEventListener('click', () => {
          if (!oneTimeButton || oneTimeButton.disabled) return;
          oneTimeButton.click();
        });
        if (oneTimePrice) new MutationObserver(syncAmount).observe(oneTimePrice, { childList: true, subtree: true, characterData: true });
        if (oneTimeButton) new MutationObserver(syncAmount).observe(oneTimeButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      buildMobileGallery();
      bindMobileLightbox();
      syncAmount();

      // v144: reveal the fixed mobile purchase bar only after its final
      // viewport geometry has been applied. This prevents the first-paint
      // slide/jump when Shopify/theme page transitions are still settling.
      root.classList.remove('asw-mobile-ui-ready');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          root.classList.add('asw-mobile-ui-ready');
        });
      });
    };
    const applyLayout = () => {
      if (mq.matches) {
        buildMobileUi();
        root.insertBefore(gallery, hero);
        buildMobileGallery();
        gallery.querySelector('.asw-watch-lower-gallery__stage')?._aswMobileGallery?.refresh?.();
        syncAmount();
      } else {
        closeFinance();
        const mobileStage = gallery.querySelector('.asw-watch-lower-gallery__stage');
        mobileStage?.style.removeProperty('--asw-mobile-gallery-height');
        mobileStage?.style.removeProperty('transition');
        if (galleryHome.parentNode && gallery.parentNode !== galleryHome.parentNode) galleryHome.after(gallery);
      }
    };

    applyLayout();
    mq.addEventListener?.('change', applyLayout);
  });
})();


(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-asw-jewelry-pdp]').forEach((root) => {
    const section = root.querySelector('[data-asw-recent]');
    const viewport = section?.querySelector('[data-asw-recent-viewport]');
    const track = section?.querySelector('[data-asw-recent-track]');
    const prev = section?.querySelector('[data-asw-recent-prev]');
    const next = section?.querySelector('[data-asw-recent-next]');
    if (!section || !viewport || !track || !prev || !next) return;
    if (section.dataset.aswRecentMobileBound === 'true') return;
    section.dataset.aswRecentMobileBound = 'true';

    const recentInner = section.querySelector('.asw-recent__inner');
    const sourceRelated = root.querySelector('[data-asw-related]:not([data-asw-recent])');
    let scrollRaf = 0;
    let resizeTimer = 0;
    let rebuilding = false;

    const allSlides = () => Array.from(track.querySelectorAll('.asw-recent__slide'));
    const directSlides = () => Array.from(track.children).filter((node) => node.classList?.contains('asw-recent__slide'));
    const pages = () => Array.from(track.children).filter((node) => node.classList?.contains('asw-recent__page'));

    const markAsRelatedMirror = () => {
      if (mq.matches) section.setAttribute('data-asw-related', '');
      else section.removeAttribute('data-asw-related');
    };

    const buildPages = () => {
      if (!mq.matches || rebuilding || pages().length) return;


      track.querySelectorAll(':scope > .asw-recent__slide.swiper-slide-duplicate').forEach((slide) => slide.remove());
      const items = directSlides().filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));
      if (!items.length) return;

      items.forEach((slide) => {
        slide.classList.remove('swiper-slide-active', 'swiper-slide-prev', 'swiper-slide-next', 'swiper-slide-duplicate');
        slide.style.removeProperty('width');
        slide.style.removeProperty('margin-right');
        slide.style.removeProperty('transform');
      });
      track.style.removeProperty('transform');
      track.style.removeProperty('transition-duration');
      track.style.removeProperty('width');

      rebuilding = true;
      const fragment = document.createDocumentFragment();
      for (let index = 0; index < items.length; index += 2) {
        const page = document.createElement('div');
        page.className = 'asw-recent__page';
        page.setAttribute('data-asw-recent-page', '');
        page.append(items[index]);
        if (items[index + 1]) page.append(items[index + 1]);
        fragment.append(page);
      }
      track.replaceChildren(fragment);
      rebuilding = false;
    };

    const unwrapPages = () => {
      if (rebuilding) return;
      const currentPages = pages();
      if (!currentPages.length) return;

      rebuilding = true;
      const fragment = document.createDocumentFragment();
      currentPages.forEach((page) => {
        Array.from(page.children).forEach((child) => fragment.append(child));
      });
      track.replaceChildren(fragment);
      rebuilding = false;
    };

    const visibleRelatedGrid = () => {
      if (!sourceRelated) return null;
      const visiblePanel = Array.from(sourceRelated.querySelectorAll('.asw-related__panel')).find((panel) => !panel.hidden);
      return visiblePanel?.querySelector('.asw-related__grid') || sourceRelated.querySelector('.asw-related__grid');
    };

    const syncGeometry = () => {
      if (!mq.matches) return;
      const grid = visibleRelatedGrid();
      const inner = recentInner || section;
      const innerRect = inner.getBoundingClientRect();
      const gridRect = grid?.getBoundingClientRect();

      let gridWidth = gridRect?.width || innerRect.width || viewport.clientWidth;
      let offset = gridRect ? gridRect.left - innerRect.left : 0;
      if (!Number.isFinite(gridWidth) || gridWidth < 1) gridWidth = viewport.clientWidth || window.innerWidth;
      if (!Number.isFinite(offset)) offset = 0;

      const readPx = (value, fallback) => {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      };
      const gridStyle = grid ? window.getComputedStyle(grid) : null;
      const sourceCards = grid
        ? Array.from(grid.children).filter((node) => node.classList?.contains('asw-related-card') && window.getComputedStyle(node).display !== 'none').slice(0, 2)
        : [];
      const firstRect = sourceCards[0]?.getBoundingClientRect();
      const secondRect = sourceCards[1]?.getBoundingClientRect();


      let padLeft = firstRect && gridRect ? Math.max(0, firstRect.left - gridRect.left) : readPx(gridStyle?.paddingLeft, 18);
      let padRight = secondRect && gridRect ? Math.max(0, gridRect.right - secondRect.right) : readPx(gridStyle?.paddingRight, 18);
      let cardGap = firstRect && secondRect ? Math.max(0, secondRect.left - firstRect.right) : readPx(gridStyle?.columnGap || gridStyle?.gap, 12);
      const padBottom = readPx(gridStyle?.paddingBottom, 10);

      if (!Number.isFinite(padLeft)) padLeft = 18;
      if (!Number.isFinite(padRight)) padRight = 18;
      if (!Number.isFinite(cardGap) || cardGap < 0) cardGap = 12;

      let pageContentWidth = firstRect && secondRect
        ? Math.max(1, firstRect.width + secondRect.width + cardGap)
        : Math.max(1, gridWidth - padLeft - padRight);


      const maxContentWidth = Math.max(1, gridWidth - padLeft - padRight);
      if (Math.abs(pageContentWidth - maxContentWidth) < 2) pageContentWidth = maxContentWidth;

      section.style.setProperty('--asw-recent-mobile-grid-width', `${gridWidth}px`);
      section.style.setProperty('--asw-recent-mobile-page-width', `${pageContentWidth}px`);
      section.style.setProperty('--asw-recent-mobile-grid-offset', `${offset}px`);
      section.style.setProperty('--asw-recent-mobile-pad-left', `${padLeft}px`);
      section.style.setProperty('--asw-recent-mobile-pad-right', `${padRight}px`);
      section.style.setProperty('--asw-recent-mobile-pad-bottom', `${padBottom}px`);
      section.style.setProperty('--asw-recent-mobile-card-gap', `${cardGap}px`);

      const firstRecentMedia = section.querySelector('.asw-recent__page .asw-related-card__media');
      const sourceMedia = grid?.querySelector('.asw-related-card__media');
      const media = firstRecentMedia || sourceMedia;
      if (media) section.style.setProperty('--asw-recent-mobile-nav-top', `${media.getBoundingClientRect().height / 2}px`);
    };

    const pageStarts = () => {
      const currentPages = pages();
      if (!currentPages.length) return [];
      const firstStart = currentPages[0].offsetLeft;
      return currentPages.map((page) => Math.max(0, page.offsetLeft - firstStart));
    };

    const nearestPageIndex = (starts) => {
      if (!starts.length) return 0;
      const left = viewport.scrollLeft;
      let nearest = 0;
      let distance = Infinity;
      starts.forEach((start, index) => {
        const delta = Math.abs(start - left);
        if (delta < distance) {
          distance = delta;
          nearest = index;
        }
      });
      return nearest;
    };

    const updateNav = () => {
      if (!mq.matches) return;
      markAsRelatedMirror();
      buildPages();
      syncGeometry();

      const currentPages = pages();
      const overflow = currentPages.length > 1;
      section.classList.toggle('has-mobile-overflow', overflow);

      if (!overflow) {
        prev.disabled = true;
        next.disabled = true;
        prev.setAttribute('aria-disabled', 'true');
        next.setAttribute('aria-disabled', 'true');
        return;
      }

      const starts = pageStarts();
      const current = nearestPageIndex(starts);
      const atStart = current <= 0 && viewport.scrollLeft <= 3;
      const lastStart = starts[starts.length - 1] || 0;
      const atEnd = current >= starts.length - 1 && viewport.scrollLeft >= lastStart - 3;

      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    const goPage = (direction) => {
      if (!mq.matches) return;
      markAsRelatedMirror();
      buildPages();
      syncGeometry();
      const starts = pageStarts();
      if (starts.length <= 1) return;

      const current = nearestPageIndex(starts);
      const target = Math.max(0, Math.min(starts.length - 1, current + direction));
      viewport.scrollTo({
        left: starts[target],
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      window.setTimeout(updateNav, reduceMotion.matches ? 0 : 320);
    };

    const clearButtonState = (button) => {
      button.blur();
      window.getSelection?.()?.removeAllRanges?.();
    };

    prev.addEventListener('pointerdown', (event) => event.preventDefault());
    next.addEventListener('pointerdown', (event) => event.preventDefault());

    prev.addEventListener('click', (event) => {
      if (!mq.matches) return;
      event.preventDefault();
      event.stopPropagation();
      goPage(-1);
      clearButtonState(prev);
    });

    next.addEventListener('click', (event) => {
      if (!mq.matches) return;
      event.preventDefault();
      event.stopPropagation();
      goPage(1);
      clearButtonState(next);
    });

    viewport.addEventListener('scroll', () => {
      if (!mq.matches) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(updateNav);
    }, { passive: true });

    const sync = () => {
      if (!mq.matches) {
        unwrapPages();
        section.removeAttribute('data-asw-related');
        section.classList.remove('has-mobile-overflow');
        section.style.removeProperty('--asw-recent-mobile-grid-width');
        section.style.removeProperty('--asw-recent-mobile-page-width');
        section.style.removeProperty('--asw-recent-mobile-grid-offset');
        section.style.removeProperty('--asw-recent-mobile-pad-left');
        section.style.removeProperty('--asw-recent-mobile-pad-right');
        section.style.removeProperty('--asw-recent-mobile-pad-bottom');
        section.style.removeProperty('--asw-recent-mobile-card-gap');
        section.style.removeProperty('--asw-recent-mobile-nav-top');
        prev.disabled = false;
        next.disabled = false;
        prev.removeAttribute('aria-disabled');
        next.removeAttribute('aria-disabled');
        return;
      }

      markAsRelatedMirror();
      buildPages();
      requestAnimationFrame(() => {
        syncGeometry();
        updateNav();
      });
    };

    const observer = new MutationObserver(() => {
      if (rebuilding) return;
      sync();
    });
    observer.observe(track, { childList: true });


    sourceRelated?.addEventListener('click', () => window.setTimeout(sync, 0));

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(sync, 120);
    }, { passive: true });

    mq.addEventListener?.('change', sync);
    sync();
    window.setTimeout(sync, 120);
    window.setTimeout(sync, 500);
  });
})();


/* v141 - product-page trade-in form, localization and viewport-safe custom selects */
(() => {
  const I18N = {
    en: {title:'Trade in your current watch',intro:'Tell us about the watch you would like to trade in. Our team will review the details and contact you with a preliminary valuation. Once approved, the agreed trade-in value can be applied towards the purchase of this watch.',name:'Name *',email:'Email *',phone:'Phone',new_watch:'New watch you want to buy *',trade_watch:'Trade-in watch *',watch_placeholder:'Brand, model or reference',set_docs:'Set / documents',set_full:'Full set with box and papers',set_papers:'Watch with papers',set_box:'Watch with box',watch_only:'Watch only',not_sure:'Not sure',condition:'Condition',excellent:'Excellent',very_good:'Very good',good:'Good',worn:'Worn',needs_service:'Needs service',short_description:'Short description *',description_placeholder:'Year, service history, visible marks, bracelet size, accessories, and any additional details.',note:'After sending this request, our team will reply and may ask you to send watch photos by email or WhatsApp.',send:'Send trade-in request',sending:'Sending request…',success:'Thank you. Your trade-in request has been sent. Our team will review the details and contact you personally.',close:'Close trade-in request'},
    de: {title:'Tauschen Sie Ihre aktuelle Uhr ein',intro:'Erzählen Sie uns von der Uhr, die Sie eintauschen möchten. Unser Team prüft die Angaben und kontaktiert Sie mit einer vorläufigen Bewertung. Nach Genehmigung kann der vereinbarte Eintauschwert beim Kauf dieser Uhr angerechnet werden.',name:'Name *',email:'E-Mail *',phone:'Telefon',new_watch:'Uhr, die Sie kaufen möchten *',trade_watch:'Uhr für den Eintausch *',watch_placeholder:'Marke, Modell oder Referenz',set_docs:'Set / Dokumente',set_full:'Komplettset mit Box und Papieren',set_papers:'Uhr mit Papieren',set_box:'Uhr mit Box',watch_only:'Nur Uhr',not_sure:'Nicht sicher',condition:'Zustand',excellent:'Ausgezeichnet',very_good:'Sehr gut',good:'Gut',worn:'Getragen',needs_service:'Service erforderlich',short_description:'Kurze Beschreibung *',description_placeholder:'Baujahr, Servicehistorie, sichtbare Spuren, Bandgröße, Zubehör und weitere Angaben.',note:'Nach dem Absenden wird sich unser Team bei Ihnen melden und Sie gegebenenfalls bitten, Fotos der Uhr per E-Mail oder WhatsApp zu senden.',send:'Trade-in-Anfrage senden',sending:'Anfrage wird gesendet…',success:'Vielen Dank. Ihre Trade-in-Anfrage wurde gesendet. Unser Team prüft die Angaben und wird Sie persönlich kontaktieren.',close:'Trade-in-Anfrage schließen'},
    fr: {title:'Faites reprendre votre montre actuelle',intro:'Parlez-nous de la montre que vous souhaitez faire reprendre. Notre équipe examinera les informations et vous contactera avec une estimation préliminaire. Après validation, la valeur de reprise convenue pourra être déduite de l’achat de cette montre.',name:'Nom *',email:'E-mail *',phone:'Téléphone',new_watch:'Montre que vous souhaitez acheter *',trade_watch:'Montre à reprendre *',watch_placeholder:'Marque, modèle ou référence',set_docs:'Coffret / documents',set_full:'Ensemble complet avec boîte et papiers',set_papers:'Montre avec papiers',set_box:'Montre avec boîte',watch_only:'Montre seule',not_sure:'Je ne sais pas',condition:'État',excellent:'Excellent',very_good:'Très bon',good:'Bon',worn:'Portée',needs_service:'Révision nécessaire',short_description:'Description courte *',description_placeholder:'Année, historique d’entretien, marques visibles, taille du bracelet, accessoires et autres informations utiles.',note:'Après l’envoi, notre équipe vous répondra et pourra vous demander des photos de la montre par e-mail ou WhatsApp.',send:'Envoyer la demande de reprise',sending:'Envoi de la demande…',success:'Merci. Votre demande de reprise a été envoyée. Notre équipe examinera les informations et vous contactera personnellement.',close:'Fermer la demande de reprise'}
  };

  document.querySelectorAll('[data-asw-jewelry-pdp]').forEach((root) => {
    const form = root.querySelector('[data-asw-trade-form]')?.closest('form');
    const tradeForm = root.querySelector('[data-asw-trade-form]');
    if (!form || !tradeForm || tradeForm.dataset.aswTradeBound === 'true') return;
    tradeForm.dataset.aswTradeBound = 'true';

    const langCode = (root.getAttribute('lang') || document.documentElement.lang || 'en').slice(0,2).toLowerCase();
    const t = I18N[langCode] || I18N.en;
    root.querySelectorAll('[data-asw-trade-i18n]').forEach((node) => {
      const key = node.dataset.aswTradeI18n;
      if (t[key]) node.textContent = t[key];
    });
    root.querySelectorAll('[data-asw-trade-i18n-placeholder]').forEach((node) => {
      const key = node.dataset.aswTradeI18nPlaceholder;
      if (t[key]) node.setAttribute('placeholder', t[key]);
    });
    root.querySelectorAll('[data-asw-trade-i18n-aria]').forEach((node) => {
      const key = node.dataset.aswTradeI18nAria;
      if (t[key]) node.setAttribute('aria-label', t[key]);
    });

    const selects = Array.from(root.querySelectorAll('[data-asw-trade-select]'));
    let activeSelect = null;
    let portal = document.querySelector('.asw-trade-select-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.className = 'asw-trade-select-portal';
      portal.setAttribute('role', 'listbox');
      portal.hidden = true;
      document.body.append(portal);
    }

    const closeSelect = (restoreFocus = false) => {
      if (!activeSelect) return;
      const toggle = activeSelect.querySelector('[data-asw-trade-select-toggle]');
      activeSelect.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      portal.hidden = true;
      portal.innerHTML = '';
      portal.style.cssText = '';
      if (restoreFocus) toggle?.focus({preventScroll:true});
      activeSelect = null;
    };

    const positionPortal = () => {
      if (!activeSelect || portal.hidden) return;
      const toggle = activeSelect.querySelector('[data-asw-trade-select-toggle]');
      if (!toggle) return;
      const rect = toggle.getBoundingClientRect();
      const vw = document.documentElement.clientWidth;
      const vh = window.visualViewport?.height || window.innerHeight;
      const edge = 10, gap = 6;
      const below = Math.max(0, vh - rect.bottom - edge - gap);
      const above = Math.max(0, rect.top - edge - gap);
      const openUp = above > below && above >= 120;
      const maxHeight = Math.max(96, Math.min(240, openUp ? above : below));
      const width = Math.max(160, Math.min(rect.width, vw - edge * 2));
      const left = Math.max(edge, Math.min(rect.left, vw - edge - width));
      portal.style.left = `${left}px`;
      portal.style.width = `${width}px`;
      portal.style.maxHeight = `${maxHeight}px`;
      if (openUp) {
        portal.style.top = 'auto';
        portal.style.bottom = `${Math.max(edge, vh - rect.top + gap)}px`;
      } else {
        portal.style.bottom = 'auto';
        portal.style.top = `${Math.min(vh - edge, rect.bottom + gap)}px`;
      }
    };

    const openSelect = (select) => {
      if (activeSelect === select && !portal.hidden) { closeSelect(); return; }
      closeSelect();
      activeSelect = select;
      const toggle = select.querySelector('[data-asw-trade-select-toggle]');
      const source = select.querySelector('[data-asw-trade-select-source]');
      const currentValue = select.querySelector('[data-asw-trade-select-value]')?.value || '';
      if (!toggle || !source) return;
      source.querySelectorAll('button[data-value]').forEach((sourceOption) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'asw-trade-select-portal__option';
        option.setAttribute('role', 'option');
        option.dataset.value = sourceOption.dataset.value || sourceOption.textContent.trim();
        option.textContent = sourceOption.textContent.trim();
        option.setAttribute('aria-selected', option.dataset.value === currentValue ? 'true' : 'false');
        portal.append(option);
      });
      select.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      portal.hidden = false;
      positionPortal();
    };

    selects.forEach((select) => {
      select.querySelector('[data-asw-trade-select-toggle]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openSelect(select);
      });
    });

    portal.addEventListener('click', (event) => {
      const option = event.target.closest('.asw-trade-select-portal__option');
      if (!option || !activeSelect) return;
      const input = activeSelect.querySelector('[data-asw-trade-select-value]');
      const label = activeSelect.querySelector('[data-asw-trade-select-label]');
      if (input) input.value = option.dataset.value || '';
      if (label) label.textContent = option.textContent.trim();
      closeSelect(true);
    });

    document.addEventListener('pointerdown', (event) => {
      if (!activeSelect || portal.hidden) return;
      if (portal.contains(event.target) || activeSelect.contains(event.target)) return;
      closeSelect();
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSelect(true); });
    window.addEventListener('resize', positionPortal, {passive:true});
    window.visualViewport?.addEventListener('resize', positionPortal, {passive:true});
    document.addEventListener('scroll', positionPortal, true);

    const content = tradeForm.querySelector('[data-asw-trade-content]');
    const success = tradeForm.querySelector('[data-asw-trade-success]');
    const status = tradeForm.querySelector('[data-asw-trade-status]');
    const openButton = root.querySelector('[data-asw-trade-open]');
    const resetView = () => {
      closeSelect();
      if (content) content.hidden = false;
      if (success) success.hidden = true;
      if (status) status.textContent = '';
    };
    openButton?.addEventListener('click', resetView);

    const iframe = document.createElement('iframe');
    iframe.name = `asw-trade-target-${form.id || Math.random().toString(36).slice(2)}`;
    iframe.hidden = true;
    iframe.setAttribute('aria-hidden', 'true');
    document.body.append(iframe);
    form.target = iframe.name;
    let submitted = false;
    iframe.addEventListener('load', () => {
      if (!submitted) return;
      submitted = false;
      if (status) status.textContent = '';
      if (content) content.hidden = true;
      if (success) success.hidden = false;
      form.reset();
      selects.forEach((select) => {
        const input = select.querySelector('[data-asw-trade-select-value]');
        const label = select.querySelector('[data-asw-trade-select-label]');
        const first = select.querySelector('[data-asw-trade-select-source] button[data-value]');
        if (first) {
          if (input) input.value = first.dataset.value || first.textContent.trim();
          if (label) label.textContent = first.textContent.trim();
        }
      });
    });
    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      closeSelect();
      submitted = true;
      if (status) status.textContent = t.sending;
    });
  });
})();
